module.exports = __webpack_public_path__ + "static/media/partager-cercle.c339081c.png";